/**
 * Telemetry text overlay in the DOM, updated only when its text changes so
 * the frame does no layout work in the common case.
 */

export class TextOverlay {
  readonly el: HTMLPreElement;
  private last = "";

  constructor(parent: HTMLElement, className: string) {
    this.el = document.createElement("pre");
    this.el.className = className;
    parent.appendChild(this.el);
  }

  set(text: string): void {
    if (text === this.last) return;
    this.last = text;
    this.el.textContent = text;
  }

  show(v: boolean): void {
    this.el.style.display = v ? "" : "none";
  }
}
